import React, { useState, useContext, useEffect } from "react";
import DayEntries from "./components/DayEntries";
import OperativeInputs from "./components/OperativeInputs";
import ShiftClosing from "./components/ShiftClosing";
import EquipmentWork from "./components/EquipmentWork";
import styles from "./TeploControlWorker.module.scss";
import { API_URL } from "../../../config";
import AuthContext from "../../../context/AuthContext";

function TeploControlWorker() {
  const [activeContent, setActiveContent] = useState("");
  const [boilerRooms, setBoilerRooms] = useState([]);
  const [selectedBoilerRoom, setSelectedBoilerRoom] = useState(null);
  const [showButtons, setShowButtons] = useState(false);
  const { authTokens } = useContext(AuthContext);

  useEffect(() => {
    const fetchBoilerRooms = async () => {
      try {
        const response = await fetch(`${API_URL}/TControl/boilerhouse/`, {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${authTokens.access}`,
          },
        });
        const data = await response.json();
        setBoilerRooms(data);
      } catch (error) {
        console.error("Ошибка при загрузке котельных:", error);
      }
    };
    fetchBoilerRooms();
  }, [authTokens]);

  const handleBoilerRoomSelect = (room) => {
    setSelectedBoilerRoom(room);
    setShowButtons(true);
  };

  const handleButtonClick = (content) => {
    setActiveContent(content);
  };

  const handleBackToSelection = () => {
    setShowButtons(false);
    setActiveContent("");
    setSelectedBoilerRoom(null);
  };

  if (!showButtons) {
    return (
      <div className={styles.startContainer}>
        <div className={styles.boilerSelection}>
          <h2 className={styles.selectionTitle}>Выберите котельную</h2>
          <select
            className={styles.boilerSelect}
            value={selectedBoilerRoom?.pk || ""}
            onChange={(e) => {
              const selected = boilerRooms.find(
                (room) => room.pk === parseInt(e.target.value)
              );
              handleBoilerRoomSelect(selected || null);
            }}
          >
            <option className={styles.boilerOption} value="">Выберите котельную...</option>
            {boilerRooms.map((room) => (
              <option className={styles.boilerOption} key={room.pk} value={room.pk}>
                {room.address}
              </option>
            ))}
          </select>
        </div>
      </div>
    );
  }

  return (
    <div className={styles.container}>
      <div className={styles.buttonContainer}>
        <button
          className={styles.backBtn}
          onClick={handleBackToSelection}
          title="Сменить котельную"
        >
          <span className={styles.arrow}></span>
        </button>
        
        <button
          className={`${styles.mainBtn} ${activeContent === "DayEntries" ? styles.activeBtn : ""}`}
          onClick={() => handleButtonClick("DayEntries")}
        >
          Ввод дневных показаний
        </button>
        <button
          className={`${styles.mainBtn} ${activeContent === "OperativeInputs" ? styles.activeBtn : ""}`}
          onClick={() => handleButtonClick("OperativeInputs")}
        >
          Ввод оперативных параметров
        </button>
        <button
          className={`${styles.mainBtn} ${activeContent === "EquipmentWork" ? styles.activeBtn : ""}`}
          onClick={() => handleButtonClick("EquipmentWork")}
        >
          Работа оборудования
        </button>
        <button
          className={`${styles.mainBtn} ${activeContent === "ShiftClosing" ? styles.activeBtn : ""}`}
          onClick={() => handleButtonClick("ShiftClosing")}
        >
          Закрытие смены
        </button>
      </div>
      
      <div className={styles.currentBoilerInfo}>
        Выбрана котельная: <strong>{selectedBoilerRoom?.address}</strong>
      </div>

      <div className={styles.contentContainer}>
        {activeContent === "DayEntries" && (
          <DayEntries selectedBoilerRoom={selectedBoilerRoom} />
        )}
        {activeContent === "OperativeInputs" && (
          <OperativeInputs selectedBoilerRoom={selectedBoilerRoom} />
        )}
        {activeContent === "ShiftClosing" && (
          <ShiftClosing selectedBoilerRoom={selectedBoilerRoom} />
        )}
        {activeContent === "EquipmentWork" && (
          <EquipmentWork selectedBoilerRoom={selectedBoilerRoom} />
        )}
      </div>
    </div>
  );
}

export default TeploControlWorker;